/**
 * Component: Pan Global Stock
 * ------------------------------------------------------------------------------
 * Detecting whether a users basket contains products located abroad
 *
 * @namespace panGlobalStock
 */
import {getCurrentVariantStockData} from '../helpers/product-inventory';

export default () => {

  /**
   * DOM Selectors.
  */
  const selectors = {
    panGlobalStockLocation: '[js-product-form="panGlobalStockLocation"]',
    panGlobalVariantListing: '[js-product-form="panGlobalVariantListing"]',
  };

  /**
   * DOM node selectors.
  */
  const nodeSelectors = {
    panGlobalStockLocation: document.querySelector(selectors.panGlobalStockLocation),
    panGlobalVariantListings: [...document.querySelectorAll(selectors.panGlobalVariantListing)],
  };

  let updatedVariantListInputs = false;

  /**
   * Initialise component.
   */
  function init() {
    setListeners();
  }

  /**
   * Set listeners.
   */
  function setListeners() {
    Frame.EventBus.listen('StockRequest', (response) => stockRequestHandler(response.variant, response.productStockData));
  }

  function stockRequestHandler(variant, productStockData) {
    if (!updatedVariantListInputs) {
      updateVariantListingInputs(productStockData);
    }

    if (!variant) { return; }

    const currentVariantStockData = getCurrentVariantStockData(variant.id, productStockData);
    const expressShippingLocation = theme.strings.expressShippingLocation;

    if (expressShippingLocation && currentVariantStockData) {
      updatePanGlobalProperty(expressShippingLocation, currentVariantStockData, nodeSelectors.panGlobalStockLocation);
    }
  }

  function updateVariantListingInputs(productStockData) {
    nodeSelectors.panGlobalVariantListings.forEach((element) => {
      const variantId = element.dataset.variant;
      const currentVariantStockData = getCurrentVariantStockData(variantId, productStockData);
      const expressShippingLocation = theme.strings.expressShippingLocation;
      if (expressShippingLocation && currentVariantStockData) {
        updatePanGlobalProperty(expressShippingLocation, currentVariantStockData, element);
      }
    });
    updatedVariantListInputs = true;
  }

  /**
   * - Checks if product has stock in allowed express location
   * - Updates product property to show pan global baskets.
   * @param {string} expressShippingLocation - Allowed Express Shipping location set in theme settings
   * @param {object} currentVariantStockData - API stock data for current variant
  */
  function updatePanGlobalProperty(expressShippingLocation, currentVariantStockData, element) {
    const matchingLocation = currentVariantStockData.find((variantLocation) => {
      return variantLocation.location.name.toLowerCase() === expressShippingLocation.toLowerCase();
    });

    if (matchingLocation && matchingLocation.available > 0) {
      element.value = false;
      return;
    }

    element.value = true;
  }

  /**
   * Expose public interface.
   */
  return {
    init,
  };
};
